export const CATALOG_ROUTES: Readonly<Record<string, string>> = {
  CATALOG: 'catalog',
  POLICIES: 'catalog_policies',
  POLICY_VERSION: 'policy_version_catalog',
  POLICY_DIFFERENCES: 'policy_diff',
  QUESTIONNAIRES: 'catalog_questionnaires',
  QUESTIONNAIRE: 'catalog_questionnaire',
  MEASURES: 'blueprints',
  ACTIONS: 'actions_catalog',
  METRICS: 'metrics',
  INDICATORS: 'indicators',
  RECURRING_TASKS: 'runtasks',
  CONNECTORS: 'connectors',
  ISSUES: 'issues',
}
